/**
 * CraftLink.Api | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const IndigenousIdSelfIdentification = {
    FirstNations: 'FirstNations',
    Metis: 'Metis',
    Inuit: 'Inuit',
    IChooseNotToRespond: 'IChooseNotToRespond',
    NotAIndigenous: 'NotAIndigenous',
    Other: 'Other'
} as const;
export type IndigenousIdSelfIdentification = typeof IndigenousIdSelfIdentification[keyof typeof IndigenousIdSelfIdentification];

